
import { Badge } from '@/components/ui/badge';

type StatusBadgeProps = {
  status: string;
  className?: string;
}

const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  // Handle different status values from orders table
  switch (status.toLowerCase()) {
    case 'completed':
      return (
        <Badge 
          variant="default" 
          className={`bg-green-600 hover:bg-green-700 ${className}`}
        >
          Completed
        </Badge>
      );
    case 'paid':
      return (
        <Badge 
          variant="default" 
          className={`bg-blue-600 hover:bg-blue-700 ${className}`}
        >
          Paid
        </Badge>
      );
    case 'created':
      return (
        <Badge 
          variant="outline" 
          className={`bg-amber-100 text-amber-800 hover:bg-amber-200 border-amber-300 ${className}`}
        >
          Created
        </Badge>
      );
    case 'pending':
      return (
        <Badge 
          variant="outline" 
          className={`bg-amber-100 text-amber-800 hover:bg-amber-200 border-amber-300 ${className}`}
        >
          Pending
        </Badge>
      );
    default:
      return (
        <Badge 
          variant="outline" 
          className={`bg-gray-100 text-gray-800 hover:bg-gray-200 border-gray-300 ${className}`}
        >
          {status}
        </Badge>
      );
  }
};

export default StatusBadge;
